<template>
  <div style="display: none;">
    <main class="p-content-plan-manual">
      <div class="p-content-plan-manual-cover">
        <div class="l-container">
          <h1 class="p-content-plan-manual-cover__title">
            <span class="c-text--main">「{{ keyword }}」</span
            >の<br />記事作成マニュアル
          </h1>
        </div>
      </div>
      <div class="p-content-plan-manual-steps">
        <ContentManualContents />
        <ContentManualStep0 :keyword="keyword" :createdAt="createdAt" />
        <ContentManualStep1 :keyword="keyword" />
        <ContentManualStep2 />
        <ContentManualStep3
          :keyword="keyword"
          :project="project"
          :tdhWordsItems="tdhWordsItems"
        />
        <ContentManualStep4 :keyword="keyword" :tdhWordsItems="tdhWordsItems" />
        <ContentManualStep5 />
        <ContentManualStep6 />
        <ContentManualStep7 :keyword="keyword" :createdAt="createdAt" />
        <ContentManualStep8
          :createdAt="createdAt"
          :keyword="keyword"
          :project="project"
        />
      </div>
    </main>
  </div>
</template>
<script>
import ContentManualContents from '@/components/contentPlans/ContentManualContents';
import ContentManualStep0 from '@/components/contentPlans/ContentManualStep0';
import ContentManualStep1 from '@/components/contentPlans/ContentManualStep1';
import ContentManualStep2 from '@/components/contentPlans/ContentManualStep2';
import ContentManualStep3 from '@/components/contentPlans/ContentManualStep3';
import ContentManualStep4 from '@/components/contentPlans/ContentManualStep4';
import ContentManualStep5 from '@/components/contentPlans/ContentManualStep5';
import ContentManualStep6 from '@/components/contentPlans/ContentManualStep6';
import ContentManualStep7 from '@/components/contentPlans/ContentManualStep7';
import ContentManualStep8 from '@/components/contentPlans/ContentManualStep8';
export default {
  props: {
    createdAt: {
      type: String,
      required: true
    },
    keyword: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    tdhWordsItems: {
      type: Array,
      required: true
    }
  },
  components: {
    ContentManualContents,
    ContentManualStep0,
    ContentManualStep1,
    ContentManualStep2,
    ContentManualStep3,
    ContentManualStep4,
    ContentManualStep5,
    ContentManualStep6,
    ContentManualStep7,
    ContentManualStep8
  }
};
</script>
